<div class="grid grid-cols-3 gap-medpace px-medpace">
    <div>
        <h5 class="font-bold">{{ `Deducted (${currency()})` }}</h5>
        <span>{{ (amount() | number: '1.2-2' : 'en-US') ?? 'Unspecified' }}</span>
    </div>
    @if (currency() !== 'USD') {
        <div>
            <h5 class="font-bold">{{ 'Deducted (USD)' }}</h5>
            <span>{{ (amountConverted() | number: '1.2-2' : 'en-US') ?? 'Unspecified' }}</span>
        </div>
    }
</div>
